/* eslint-disable no-useless-catch */
import { API } from "../api";
import { CLIENT_PRODUCTS } from "../constants/url.constant";

export const GET_CLIENT_PRODUCTS = "GET_CLIENT_CLIENT_PRODUCTS";
export const GET_CLIENT_PRODUCT = "GET_CLIENT_PRODUCT";
export const ADD_CLIENT_PRODUCT = "ADD_CLIENT_PRODUCT";
export const DELETE_CLIENT_PRODUCT = "DELETE_CLIENT_PRODUCT";
export const UPDATE_CLIENT_PRODUCT = "UPDATE_CLIENT_PRODUCT";

export const getProducts = (clientId, params = {}) => {
  return async (dispatch) => {
    try {
      const res = await API.get(
        CLIENT_PRODUCTS.replace("clientId", clientId),
        {
          params
        }
      );
      if (Object.keys(params).length) {
        dispatch({
          type: GET_CLIENT_PRODUCTS,
          payload: res
        });
      }
      return res;
    } catch (error) {
      throw error;
    }
  };
};

export const getProductByID = (clientId, productId) => {
  return async (dispatch) => {
    try {
      const res = await API.get(
        `${CLIENT_PRODUCTS.replace("clientId", clientId)}/${productId}`
      );
      dispatch({
        type: GET_CLIENT_PRODUCT,
        payload: res
      });
      return res;
    } catch (error) {
      throw error;
    }
  };
};

export const addClientProduct = (clientId, data) => {
  return async (dispatch) => {
    try {
      const res = await API.post(
        CLIENT_PRODUCTS.replace("clientId", clientId),
        data
      );
      dispatch({
        type: ADD_CLIENT_PRODUCT,
        payload: data
      });
      return res;
    } catch (error) {
      throw error;
    }
  };
};

export const updateClientProduct = (clientId, productId, body) => {
  return async (dispatch) => {
    try {
      await API.put(
        `${CLIENT_PRODUCTS.replace("clientId", clientId)}/${productId}`,
        body
      );
      dispatch({
        type: UPDATE_CLIENT_PRODUCT,
        payload: { productId, ...body }
      });
    } catch (error) {
      throw error;
    }
  };
};

export const deleteClientProduct = (clientId, productId) => {
  return async (dispatch) => {
    try {
      await API.delete(
        `${CLIENT_PRODUCTS.replace("clientId", clientId)}/${productId}`);
      dispatch({
        type: DELETE_CLIENT_PRODUCT
      });
    } catch (error) {
      throw error;
    }
  };
};

export default function reducer(
  state = { clientProductTableRows: [], totalRows: 0 },
  { type, payload }
) {
  switch (type) {
    case GET_CLIENT_PRODUCTS:
      return {
        ...state,
        ClientProductTableColumns: payload.columns,
        clientProductTableRows: payload.rows,
        totalRows: payload.count
      };
    case GET_CLIENT_PRODUCT:
      return {
        ...state,
        productDetail: payload
      };
    case ADD_CLIENT_PRODUCT:
      return {
        ...state,
        totalRows: state.totalRows + 1,
        clientProductTableRows: [
          ...state.clientProductTableRows,
          { ...payload }
        ]
      };
    case DELETE_CLIENT_PRODUCT:
      return {
        ...state,
        totalRows: state.totalRows - 1,
        clientProductTableRows: state.clientProductTableRows.filter(
          (client) => client.id !== payload
        )
      };
    case UPDATE_CLIENT_PRODUCT:
      return {
        ...state,
        clientProductTableRows: state.clientProductTableRows.map(
          (client) => (client.id === payload.id ? { ...payload } : client)
        )
      };
    default:
      return state;
  }
}
